import o from "./_root.js";
var r = o["__core-js_shared__"];
const t = r;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_coreJsData.js
// module id = 1503
// module chunks = 67